import requirementsRoutes from 'modules/requirements/common/routing/routes'

const routes = {
  root: `${requirementsRoutes.root}/details`,
}

export default routes
